<template>
  <div id="app">
    <RouterView />

    <!-- Stacked Notifications -->
    <div class="notifications-container">
      <PatientNotification
        v-for="(notification, index) in patientNotifications"
        :key="notification.id || index"
        :data="notification"
        @close="removeNotification(index)"
      />
    </div>

    <Toasts
      :rtl="true"
      :max-messages="5"
      :showProgress="false"
      :time-out="10000"
      :closeable="false"
    />
  </div>
</template>

<script>
import axios from "axios"
import router from "@/router"
import appConfig from "@/app.config"
import PatientNotification from "@/components/PatientNotification.vue"

axios.defaults.baseURL = "https://admin.daherzfamilydoctors.com/api"

const token = localStorage.getItem("token")
if (token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`
}

export default {
  name: "App",
  components: {
    PatientNotification,
  },
  data() {
    return {
      patientNotifications: [], // Array for stacked notifications
    }
  },
  created() {
    axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response && error.response.status === 401) {
          this.$toast.error("Session expired. Please log in again.", { timeout: 3000 })
          setTimeout(() => { this.logout() }, 1500)
        }
        return Promise.reject(error)
      }
    )

    const user = JSON.parse(localStorage.getItem("user"))
    if (!user) return

    this.$echo
      .private(`patients`)
      .listen(".patient.added", (e) => {
        this.patientNotifications.push(e)
      })
  },
  methods: {
    removeNotification(index) {
      this.patientNotifications.splice(index, 1)
    },
    logout() {
      localStorage.removeItem("token")
      localStorage.removeItem("user")
      router.push("/")
    },
  },
  page: {
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
}
</script>

<style scoped>
/* Container for stacked notifications */
.notifications-container {
  position: fixed;
  top: 20px;
  right: 20px;
  width: 360px;
  display: flex;
  flex-direction: column;
  gap: 12px; /* space between notifications */
  z-index: 9999;
}
</style>
